export const FETCH_ACTIVITY_BOARD = "app/ActivityBoard/FETCH";
export const FETCH_ACTIVITY_BOARD_SUCCESS = "app/ActivityBoard/FETCH_SUCCESS";
export const FETCH_ACTIVITY_BOARD_FAILURE = "app/ActivityBoard/FETCH_FAILURE";
